import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import Loader from '../../_components/molecules/Loader';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  Download,
  ReportOverviewCard,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { Button } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import ClauseDetail from '../../_components/organisms/ClauseDetail';
import { cellStyles1 } from '../../_components/molecules/PatientDetailsMedicalHistoryTab';
import {
  Columns,
  cellStyles2,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/BasicTable';
import RecommendationInfo from '../../_components/atoms/RecommendationInfo';

import {
  ClauseDetailsFormatter,
  getBarColor,
} from '../../core-utils/helper-utils/contractAIQHelper';
import _ from 'lodash';
import axios from 'axios';
import properties from '../../core-utils/properties';
import { useStores } from '../../stores';
import Snackbar from '../../_components/atoms/Snackbar';
import contractAIQConstants from '../../core-utils/messages/ContractAIQConstants';
import EmptyData from '../../_components/atoms/Icons/EmptyData';

export interface ContractReportProps {}

export const checkOfListColumns: Columns[] = [
  {
    name: 'Questions',
    align: 'left',
    cellStyles: cellStyles1,
    width: '',
  },
  {
    name: 'Standardization parameter',
    align: 'left',
    cellStyles: cellStyles2,
    width: '',
  },
  {
    name: 'Compilance',
    align: 'left',
    cellStyles: cellStyles2,
    width: '',
  },
];

const ContractReportPage: React.FC<ContractReportProps> = observer(({}) => {
  const riskStaticData = contractAIQConstants.RISK_STATIC_DATA;
  const [loading, setLoading] = useState<boolean>(false);
  const [loader] = useState<any>(<Loader />);
  const [activeTabData, setActiveTabData] = useState<any>({});
  const [recData, setRecData] = useState<any>(riskStaticData[0]);

  const useStyles = makeStyles()(() => ({
    title: {
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '22px',
      color: `${patientAccessTheme.palette.text.highemphasis}`,
    },
    emptyDataIconGrid: {
      marginTop: '200px',
      marginBottom: '24px',
    },
  }));
  const { classes } = useStyles();

  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const [pageData, setPageData] = useState<any>([]);
  const contractStore = useStores().contractAiqStore;

  const handleOnClick = (value: string) => {
    const activeData = pageData?.find((item: any) => item._id === value);
    setActiveTabData(activeData ?? {});
    setRecData(riskStaticData.find((item: any) => item.title === value));
  };

  const SideBar = () => {
    return (
      <Grid
        style={{
          height: 'calc(100vh - 59px)',
          width: '410px',
          background: patientAccessTheme.palette.status.white,
          position: 'absolute',
          left: '69px',
          top: '59px',
          zIndex: 100,
        }}
      >
        <Grid
          style={{
            height: '90px',
            padding: '8px 20px',
            background: patientAccessTheme.palette.status.white,
            borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography className={classes.title}>Report Summary</Typography>
          <Button
            variant="outlined"
            color="primary"
            height="33px"
            width="180px"
            borderRadius="4px"
            startIcon={<Download />}
            label={'Download Report'}
          />
        </Grid>
        {pageData.map((data: any) => (
          <ReportOverviewCard
            title={data?._id}
            value={data?.score}
            key={data._id}
            tooltip={
              riskStaticData.find((item: any) => item.title === data?._id)
                ?.tooltip
            }
            handleOnClick={() => handleOnClick(data?._id)}
            isActive={activeTabData?._id === data?._id}
            rootStyles={{
              gap: '0.5rem',
              height: '90px',
              width: '410px',
              padding: '8px 20px',
              flexWrap: 'nowrap',
            }}
            barColor={getBarColor(data?.score)}
          />
        ))}
      </Grid>
    );
  };

  const getRiskDetails = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.riskReportClauses,
        {
          service_agreement_id: contractStore.serviceAgreementId,
        },
      )
      .then((response) => {
        if (response.status === 200) {
          setPageData(response.data?.data);
          setActiveTabData(response.data?.data?.[0] ?? {});
        }
      })
      .catch((error) =>
        handleOpenSnackBar(error.response?.data?.error, 'error', 6000),
      )
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);
    getRiskDetails();
  }, []);

  return (
    <>
      {loading ? (
        loader
      ) : pageData.length === 0 ? (
        <Grid
          container
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Grid className={classes.emptyDataIconGrid}>
            <EmptyData />
          </Grid>
          <Grid>
            <Typography
              fontSize="14px"
              fontType="regular"
              lineHeight="24.78px"
              textColor={patientAccessTheme.palette.text.mediumemphasis}
            >
              {'No Risk Report Data Available'}
            </Typography>
          </Grid>
        </Grid>
      ) : (
        <Grid
          style={{
            display: 'flex',
            width: '1200px',
          }}
        >
          <SideBar />
          <Grid style={{ marginTop: '2rem', marginLeft: '450px' }}>
            <RecommendationInfo
              title={activeTabData?._id}
              subTitle={recData?.subTitle}
              objectives={recData?.objectives}
              tooltip={recData?.tooltip}
            />
            <Typography
              className={classes.title}
              style={{
                margin: '1rem 0',
              }}
            >
              Clauses
            </Typography>
            {!_.isEmpty(activeTabData) &&
              activeTabData?.clauses_data.map((clauseData: any) => (
                <ClauseDetail
                  title={clauseData?.clause_name}
                  analysis={clauseData?.analysis}
                  metCount={ClauseDetailsFormatter(clauseData).metCount}
                  unMetCount={ClauseDetailsFormatter(clauseData).unMetCount}
                  chipValue={clauseData?.risk_category}
                  columns={checkOfListColumns}
                  rowsData={ClauseDetailsFormatter(clauseData).rowData}
                  tooltip={clauseData?.aim_of_the_clause}
                />
              ))}
          </Grid>
        </Grid>
      )}
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
    </>
  );
});

export default ContractReportPage;
